import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);

const chartOptions = (props) => {
  return {
    chart: {
      type: "line",
      zoomType: "x",
      backgroundColor: "#2b2b2b",
    },

    title: {
      text: "",
    },

    yAxis: [
      {
        title: {
          text: props.yAxisLabelPrimary,
          style: {
            color: "#ffffff",
          },
        },
        labels: {
          style: {
            color: "#ffffff",
          },
        },
      },
      {
        opposite: true,
        title: {
          text: props.yAxisLabelSecondary,
          style: {
            color: "#ffffff",
          },
        },
        labels: {
          style: {
            color: "#ffffff",
          },
        },
      },
    ],

    xAxis: {
      accessibility: {
        rangeDescription: "Time Series",
      },
      labels: {
        style: {
          color: "#ffffff",
        },
      },
    },

    legend: {
      layout: 'horizontal',
      itemWidth: 350,
      itemStyle: {
        color: "#ffffff",
        textOverflow: "ellipsis"
      },
      itemHiddenStyle: {
        color: "#919191",
      },
    },

    plotOptions: {
      series: {
        lineWidth: 2,
        marker: {
          radius: 1,
        },
      },
    },

    series: props.chartData,

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
          },
        },
      ],
    },
  };
};

const emptyChart = () => {
  return {
    chart: {
      backgroundColor: "#2b2b2b",
    },
    title: {
      text: "Click on any of the maps to show the change over time for the selected climate information at the selected location.",
      style: {
        color: "#ffffff",
      },
      verticalAlign: 'middle'
    },
    yAxis: [
      {
        title: {
          text: ""
        }
      },
      {
        opposite: true,
        title: {
          text: "",
        }
      }
    ],
    
    series: [],
  };
};

const TimeSeriesLine = (props) => {
  // console.log(props)
  let options =
    props.chartData && props.chartData.length > 0
      ? chartOptions(props)
      : emptyChart();

  return (
    <HighchartsReact
      highcharts={Highcharts}
      containerProps={{
        style: { height: "calc(100% - 24px)", width: "100%", marginTop: "8px" },
      }}
      options={options}
      oneToOne={true}
    />
  );
};

export default TimeSeriesLine;
